var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDescriptionIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M7 12.25v0A5.25 5.25 0 0 1 1.75 7v0C1.75 4.1 4.1 1.75 7 1.75v0c2.9 0 5.25 2.35 5.25 5.25v0c0 2.9-2.35 5.25-5.25 5.25Z",
  stroke: "#828C9C",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 7.73v-.147c0-.476.295-.735.59-.933.288-.194.577-.447.577-.914a1.166 1.166 0 1 0-2.333 0M7 9.333A.146.146 0 1 0 7 9.625.146.146 0 0 0 7 9.333",
  stroke: "#828C9C",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgDescriptionIcon;